import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  GetFavoriteMarketsWithNewGoodsParams,
  GetFavoriteMarketsWithNewGoodsResponse,
} from './types';

/**
 * - 즐겨찾는 마켓 + 신상품 카운트
 */
export const getFavoriteMarketsWithNewGoods = async ({
  filter = 'all',
}: GetFavoriteMarketsWithNewGoodsParams = {}) => {
  return defaultHttpClient
    .request<GetFavoriteMarketsWithNewGoodsResponse>({
      method: 'GET',
      url: '/api/v2/favorite-markets/with-new-goods/',
      params: { filter },
    })
    .then(result => result.data);
};
